import { appRoutes } from 'routes';
import { Link as RouterLink } from 'react-router-dom';
import { Link } from '@material-ui/core';
import i18n from 'i18next';

const locals = () => {
  return {
    rootLocals: {
      path: appRoutes.rootPath(),
      label: 'root',
      banner: {
        title: i18n.t('components.NonAuthHomePage.Banner.root.title'),
        subtitle: i18n.t('components.NonAuthHomePage.Banner.root.subtitle'),
        button: {
          text: i18n.t('components.NonAuthHomePage.Banner.root.buttonText'),
          props: {
            to: appRoutes.surveyPath(),
            component: RouterLink,
          },
        },
      },
      description: [
        {
          link: i18n.t('components.NonAuthHomePage.Description.root.sections.first.link'),
          title: i18n.t('components.NonAuthHomePage.Description.root.sections.first.title'),
          description: i18n.t('components.NonAuthHomePage.Description.root.sections.first.description'),
        },
        {
          link: i18n.t('components.NonAuthHomePage.Description.root.sections.second.link'),
          title: i18n.t('components.NonAuthHomePage.Description.root.sections.second.title'),
          description: i18n.t('components.NonAuthHomePage.Description.root.sections.second.description'),
        },
        {
          link: i18n.t('components.NonAuthHomePage.Description.root.sections.third.link'),
          title: i18n.t('components.NonAuthHomePage.Description.root.sections.third.title'),
          description: i18n.t('components.NonAuthHomePage.Description.root.sections.third.description'),
        },
      ],
    },
    loanOfficerLocals: {
      path: appRoutes.loanOfficerPath(),
      label: 'loanOfficer',
      banner: {
        title: i18n.t('components.NonAuthHomePage.Banner.loanOfficerRoot.title'),
        subtitle: i18n.t('components.NonAuthHomePage.Banner.loanOfficerRoot.subtitle'),
        button: {
          text: i18n.t('components.NonAuthHomePage.Banner.loanOfficerRoot.buttonText'),
          props: {
            href: 'https://calendly.com/eric-mager/30min',
            target: '_blank',
            component: Link,
          },
        },
      },
      description: [
        {
          link: i18n.t('components.NonAuthHomePage.Description.loanOfficerRoot.sections.first.link'),
          title: i18n.t('components.NonAuthHomePage.Description.loanOfficerRoot.sections.first.title'),
          description: i18n.t('components.NonAuthHomePage.Description.loanOfficerRoot.sections.first.description'),
        },
        {
          link: i18n.t('components.NonAuthHomePage.Description.loanOfficerRoot.sections.second.link'),
          title: i18n.t('components.NonAuthHomePage.Description.loanOfficerRoot.sections.second.title'),
          description: i18n.t('components.NonAuthHomePage.Description.loanOfficerRoot.sections.second.description'),
        },
        {
          link: i18n.t('components.NonAuthHomePage.Description.loanOfficerRoot.sections.third.link'),
          title: i18n.t('components.NonAuthHomePage.Description.loanOfficerRoot.sections.third.title'),
          description: i18n.t('components.NonAuthHomePage.Description.loanOfficerRoot.sections.third.description'),
        },
      ],
    },
    realEstateAgentLocals: {
      path: appRoutes.realEstateAgentPath(),
      label: 'realEstateAgent',
      banner: {
        title: i18n.t('components.NonAuthHomePage.Banner.realEstateAgentRoot.title'),
        subtitle: i18n.t('components.NonAuthHomePage.Banner.realEstateAgentRoot.subtitle'),
        button: {
          text: i18n.t('components.NonAuthHomePage.Banner.realEstateAgentRoot.buttonText'),
          props: {
            href: 'https://calendly.com/eric-mager/30min',
            target: '_blank',
            component: Link,
          },
        },
      },
      description: [
        {
          link: i18n.t('components.NonAuthHomePage.Description.realEstateAgentRoot.sections.first.link'),
          title: i18n.t('components.NonAuthHomePage.Description.realEstateAgentRoot.sections.first.title'),
          description: i18n.t('components.NonAuthHomePage.Description.realEstateAgentRoot.sections.first.description'),
        },
        {
          link: i18n.t('components.NonAuthHomePage.Description.realEstateAgentRoot.sections.second.link'),
          title: i18n.t('components.NonAuthHomePage.Description.realEstateAgentRoot.sections.second.title'),
          description: i18n.t('components.NonAuthHomePage.Description.realEstateAgentRoot.sections.second.description'),
        },
        {
          link: i18n.t('components.NonAuthHomePage.Description.realEstateAgentRoot.sections.third.link'),
          title: i18n.t('components.NonAuthHomePage.Description.realEstateAgentRoot.sections.third.title'),
          description: i18n.t('components.NonAuthHomePage.Description.realEstateAgentRoot.sections.third.description'),
        },
      ],
    },
  };
};

export default locals;



// WEBPACK FOOTER //
// ./src/components/NonAuthHomePage/data.js